import React from 'react';

import useTimeById from './UseTimeById';
import Constants from '@usas/ui-web/utils/Constants';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const TimeById = () => {
  useTimeById();

  return (
    <PopUpModal
      widthPct={50}
      maxWidth={250}
      title={Constants.LOADING_MSG}
      displayPopUp={true} />
  );
};

export default TimeById;